export default __webpack_public_path__ + "static/Calibre-Semibold-6972688a249bd53a6c7e69a89e50cdd6.woff";